import './scss/bootstrap.scss';
import './scss/swiper.scss';
import './scss/fontawesome.scss';

import './scss/style.scss';

import 'bootstrap/js/dist/collapse';

require('./_favicons.js');
require('./_svg.js');
require('./_webp.js');

require('./js/animation');
require('./js/cookieconsent');
require('./js/navigation');
require('./js/video');
require('./js/animation');
require('./js/slider');
require('./js/masonry');
require('./js/visual');
require('./js/map');
require('./js/form');
